/*
 * Partners Forms WPL
 * Author: Victor Tihai, WPlook Studio
 */

// Import Bootstrap
import { Util, Dropdown, Offcanvas, Popover, Button, Modal } from 'bootstrap';
